import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useCallback } from 'react';
import { COLUMNS_TYPES, COLUMNS_VALUES_KEYS, } from '../../../data/data1d/MultipleAnalysis';
import { useDispatch } from '../../context/DispatchContext';
import DeleteButton from '../../elements/Tab/DeleteButton';
import DropDownButton from '../../elements/dropDownButton/DropDownButton';
import { DELETE_ANALYZE_SPECTRA_RANGE } from '../../reducer/types/Types';
const styles = (styles) => css `
  position: relative;

  .delete {
    position: absolute;
    right: 0px;
    top: 0px;
  }

  .container {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
  }

  .dropDown-container {
    justify-content: flex-start;
    align-items: flex-start;
  }

  .label-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    min-height: 45px;
  }

  .label {
    text-align: center;
  }

  ${styles}
`;
const columnsFilters = [
    { key: COLUMNS_VALUES_KEYS.RELATIVE, label: 'Relative' },
    { key: COLUMNS_VALUES_KEYS.ABSOLUTE, label: 'Absolute' },
    { key: COLUMNS_VALUES_KEYS.MIN, label: 'Min Intensity' },
    { key: COLUMNS_VALUES_KEYS.MAX, label: 'Max Intensity' },
];
function ColumnHeader({ charLabel, rangeLabel, data, onColumnFilter, }) {
    const dispatch = useDispatch();
    const deleteHandler = useCallback(() => {
        dispatch({ type: DELETE_ANALYZE_SPECTRA_RANGE, colKey: charLabel });
    }, [charLabel, dispatch]);
    return (_jsxs("div", { css: styles, children: [_jsxs("div", { className: "container", children: [data.type === COLUMNS_TYPES.NORMAL && (_jsx("div", { className: "dropDown-container", children: _jsx(DropDownButton, { data: columnsFilters, formatSelectedValue: (item) => item.label.slice(0, 3), selectedKey: data.valueKey, onSelect: onColumnFilter }) })), _jsxs("div", { className: "label-container", children: [_jsxs("span", { className: "label", children: [" ", charLabel] }), _jsx("span", { className: "label", children: rangeLabel })] })] }), _jsx(DeleteButton, { onDelete: deleteHandler })] }));
}
export default ColumnHeader;
